import { useState } from "react"
import { Section } from "../styled/Containers.style"
import { TextCtaSub } from "../styled/Text.style"
import Drawer from "./Drawer"

export interface DrawerForExamplesProps {
    ctaLabel?: string
    drawerTitleLabel?: string
    drawerContent?: any
    drawerPreviewCustomClass?: string
    onOpenCb?: Function
}

/* istanbul ignore next */
const DrawerForExamples = (props: DrawerForExamplesProps) => {
    const { ctaLabel, drawerTitleLabel, drawerContent, drawerPreviewCustomClass, onOpenCb } = props
    const [showDrawer, setShowDrawer] = useState(false)
    return (
        <>
            {
                <Section>
                    <TextCtaSub
                        onClick={() => { setShowDrawer(true) }}>{ctaLabel}</TextCtaSub>
                </Section>
            }
            {showDrawer && <Drawer
                previewCustomClass={drawerPreviewCustomClass || "light-title"}
                onClose={() => setShowDrawer(false)}
                titleImageDetail={drawerTitleLabel}
                onOpenCb={onOpenCb}
            >
                {drawerContent}
            </Drawer>
            }
        </>
    )
}

export default DrawerForExamples
